import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SendNowTriggerService {
  sendReportNowClicked$ = new Subject<string>();
}
